/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Create_Team_FailedInputs */



/**
* | output |
* | --- |
* | "Error creating new team. {error}" |
*
* @param {Team_Manager_Create_Team_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_failed = /** @type {((inputs: Team_Manager_Create_Team_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la création de la nouvelle équipe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Erstellen des neuen Teams. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante la creazione del nuovo team. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при создании новой команды. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al crear nuevo equipo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建新团队时出错。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`新しいチームの作成中にエラーが発生しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`नई टीम बनाने में त्रुटि। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao criar nova equipe. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error creating new team. ${i?.error}`)
});